/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//ran this thru claudes code refactoring tool



// redesign this component to look more elegant and polished and add accents
// use tailwind css in the className directive 
// Colors come from dynamic seller props — use hex + opacity string concatenation (e.g. sellerPrimaryColor1 + '20') for tints, never hardcode colors."
// keep the main image squared - no rounded corners
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task


import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { FaHeart } from "react-icons/fa6";
import { FaEye } from "react-icons/fa";
import { MdOutlineRestaurantMenu } from "react-icons/md";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { FaUser } from "react-icons/fa6";

import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

import { add_to_cart, add_to_wishlist, messageClear } from '../../store/reducers/cartReducer';
import { currencyFormat } from '../CurrencyFormat';
import Rating from '../Rating';
import SkeletonWithImage from '../SkeletonWithImage';
import Modal2 from '../Modal2';
import toast from 'react-hot-toast';

// ─── Helpers ─────────────────────────────────────────────────────────────────

/** Returns a badge label if the product qualifies, otherwise null */
const getProductBadge = (p) => {
    const now = Date.now();
    const created = p.createdAt ? new Date(p.createdAt).getTime() : 0;
    const isNew = now - created < 1000 * 60 * 60 * 24 * 21; // < 21 days old
    if (isNew) return 'New';
    if (p.rating >= 4.5) return 'Popular';
   // if (p.discount > 0) return `${p.discount}% off`;
    return null;
};

// ─── Action icon button onKeyDown, ───────────────────────────────────────────────────────
const ProductActionButton = ({ onClick,  icon, tooltip, tooltipStyle, primaryColor, hexColorSuffix }) => (
    <li
        role="button"
        tabIndex={0}
        onClick={onClick}
        //onKeyDown={onKeyDown}
        className="w-9 h-9 cursor-pointer bg-white flex justify-center items-center rounded-full
            shadow-md border border-gray-700 transition-transform duration-200
            hover:scale-110 active:scale-95"
            style={{ borderColor: primaryColor + hexColorSuffix }}>
        <div className="icon-container">
            <span className="icon flex justify-center items-center text-sm" 
                style={{ 
                    color: primaryColor + hexColorSuffix,
                    borderColor: primaryColor + hexColorSuffix
                }}>
                {icon}
            </span>
            <div className="tooltip" style={tooltipStyle}>{tooltip}</div>
        </div>
    </li>
);

// ─── Section title with flanking rules ───────────────────────────────────────
const SectionTitle = ({ title, primaryColor, sellerColorSuffixLight, sellerColorSuffixMedium, sellerColorSuffixDark }) => (
    <div className="flex items-center gap-4 mb-4">
        <span
            className="flex-1 h-px"
            style={{ background: `linear-gradient(to right, transparent, ${primaryColor}${sellerColorSuffixMedium})` }}
        />
        <div
            className="text-md sm:text-sm font-semibold tracking-[0.18em] uppercase whitespace-nowrap"
            style={{ color: primaryColor + sellerColorSuffixDark }}>
            {title}
        </div>
        <span
            className="flex-1 h-px"
            style={{ background: `linear-gradient(to left, transparent, ${primaryColor}${sellerColorSuffixMedium})` }}
        />
    </div>
);

// ─── Main component ───────────────────────────────────────────────────────────
const SwiperProducts = ({ products, title, suppressToasts = false }) => {
    const dispatch   = useDispatch();
    const navigate   = useNavigate();

    const { seller }   = useSelector(state => state.seller);
    const { userInfo } = useSelector(state => state.auth);
    const { errorMessage, successMessage } = useSelector(state => state.cart);

    const cfg = useMemo(() => ({
        primaryColor:                       seller?.frontEndPrimaryColor1   ?? '#1a1a1a',
        secondaryColor:                     seller?.frontEndSecondaryColor1 ?? '#ffffff',
        sellerArrHexOpacityColorSuffixes:   seller?.hexOpacityColorSuffixes?.split(';') || [],
        shoppingTerm:                       seller?.shoppingTerm            ?? 'Cart',
        productPlural:                      seller?.productPluralTerm       ?? 'Products',
        showPayments:                       seller?.isVisibleSitePayments   === 'Show',
        showWishlist:                       seller?.isVisibleSiteWishlist   === 'Show',
        showRating:                         seller?.isVisibleSiteRating     === 'Show',
        showChat:                           seller?.isVisibleSiteChat       === 'Show',
    }), [seller]);

    //const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];// 'FF;80;1A' Darkest is FF, Medium is 80, Lightest is 1A
    const sellerColorSuffixDark = cfg.sellerArrHexOpacityColorSuffixes[0] || 'FF';
    const sellerColorSuffixMedium = cfg.sellerArrHexOpacityColorSuffixes[1] || '80';
    const sellerColorSuffixLight = cfg.sellerArrHexOpacityColorSuffixes[2] || '1A';


    const tooltipStyle = useMemo(() => ({
        color:           'white',
        backgroundColor: cfg.primaryColor,
    }), [cfg.primaryColor]);

    // Per-product portion sizes
    const [portionSizes, setPortionSizes] = useState({});
    const setProductPortionSize = useCallback((productId, size) =>
        setPortionSizes(prev => ({ ...prev, [productId]: size })), []);

    // Modal
    const [modalProduct, setModalProduct] = useState(null);
    const openModal  = useCallback((p) => setModalProduct(p), []);
    const closeModal = useCallback(() => setModalProduct(null), []);

    // Navigation
    const redirect_chat_page = useCallback((topic) => {
        navigate(userInfo ? `/customerDashboard/chat/${topic}` : '/login');
    }, [userInfo, navigate]);

    // Cart / wishlist
    const add_to_cart_local = useCallback((productId) => {
        if (!userInfo) { navigate('/login'); return; }
        dispatch(add_to_cart({
            userId: userInfo.id,
            quantity: 1,
            productId,
            portionSize: portionSizes[productId] ?? '',
        }));
    }, [userInfo, navigate, dispatch, portionSizes]);

    const add_to_wishlist_local = useCallback((p) => {
        if (!userInfo) { navigate('/login'); return; }
        dispatch(add_to_wishlist({
            userId:       userInfo.id,
            productId:    p._id,
            name:         p.name,
            price:        p.price,
            image:        p.images[0],
            discount:     p.discount,
            rating:       p.rating,
            slug:         p.slug,
            portionSizes: p.portionSizes,
            description:  p.description,
            byThePan:     p.byThePan,
        }));
    }, [userInfo, navigate, dispatch]);

    useEffect(() => {
        if (suppressToasts) return;
        if (successMessage) { toast.success(successMessage); dispatch(messageClear()); }
        if (errorMessage)   { toast.error(errorMessage);     dispatch(messageClear()); }
    }, [successMessage, errorMessage, suppressToasts, dispatch]);

    if (!products || products.length === 0) return null;

    return (
        <>
            <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] mx-auto py-2">

                <SectionTitle
                    title={title || `Related ${cfg.productPlural}`}
                    primaryColor={cfg.primaryColor}
                    sellerColorSuffixLight={sellerColorSuffixLight}
                    sellerColorSuffixMedium={sellerColorSuffixMedium}
                    sellerColorSuffixDark={sellerColorSuffixDark}
                />

                <Swiper
                    slidesPerView="auto"
                    breakpoints={{ 1280: { slidesPerView: 3 }, 565: { slidesPerView: 2 } }}
                    spaceBetween={16}
                    loop={true}
                    pagination={{ clickable: true, el: '.custom_bullet' }}
                    modules={[Pagination]}
                    className="mySwiper">
                    {products.map((p) => {
                        const portionSize = portionSizes[p._id] ?? '';
                        const badge       = getProductBadge(p);

                        const descSnippet = p.description
                            ? p.description.length > 50
                                ? `${p.description.substring(0, 50)}…`
                                : p.description
                            : '';

                        return (
                            <SwiperSlide key={p._id}>
                                {/*
                                  Card — white background, hairline border, lifts on hover.
                                  The top accent bar is 3px and uses primaryColor.
                                */}
                                <div
                                    className="flex flex-col bg-white border border-gray-100 rounded-sm
                                        shadow-sm transition-shadow duration-300 hover:shadow-xl
                                        overflow-hidden"
                                    style={{ boxShadow: '0 1px 14px rgba(0,0,0,0.06)' }}>
                                    {/* ── Top accent bar ── */}
                                    
                                    <div
                                        className="group rounded-2xl overflow-hidden bg-white
                                            border-t
                                            shadow-sm
                                            transition-all duration-300 ease-out
                                            hover:-translate-y-1.5 hover:shadow-xl"
                                        style={{ 
                                            '--ring-color': cfg.primaryColor + sellerColorSuffixMedium, // for focus ring
                                            borderRadius: '8px',
                                            borderTop: `8px solid ${cfg.primaryColor}${sellerColorSuffixMedium}`,
                                            boxShadow: `0 4px 20px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.9)`,
                                        }}>
                                        <div className="h-[3px] w-full" style={{ backgroundColor: cfg.primaryColor + sellerColorSuffixMedium }} />

                                        {/* ── Image + hover actions ── */}
                                        <div className="relative group overflow-hidden h-[210px] md:h-[270px] xs:h-[170px]">
                                            <SkeletonWithImage
                                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                                src={p.images[0]}
                                                alt={p.name}
                                            />

                                            {/* Gradient scrim — appears on hover for action button legibility */}
                                            <div
                                                className="hidden absolute inset-0 opacity-0 group-hover:opacity-100
                                                        transition-opacity duration-300 pointer-events-none"
                                                style={{ background: `linear-gradient(to top, ${cfg.primaryColor}80 0%, transparent 55%)` }}
                                            />

                                            {/* Badge */}
                                            {badge && (
                                                <div
                                                    className="absolute top-3 left-3 px-2 py-0.5 text-[10px]
                                                        font-semibold tracking-widest uppercase rounded-sm text-white
                                                            shadow-sm"
                                                    style={{ backgroundColor: cfg.primaryColor + sellerColorSuffixMedium }}>
                                                    {badge}
                                                </div>
                                            )}

                                            {/* Action buttons — slide up on hover onKeyDown={(e) => e.key === 'Enter' && add_to_cart_local(p._id)}
                                                     */}
                                            <ul className="flex transition-all duration-500 -bottom-12 justify-center
                                                items-center gap-2 absolute w-full group-hover:bottom-4 px-2">
                                                <ProductActionButton
                                                    onClick={() => add_to_cart_local(p._id)}
                                                    icon={<><span>+</span><MdOutlineRestaurantMenu size={18} /></>}
                                                    tooltip={<>Add To<br />{cfg.shoppingTerm}</>}
                                                    tooltipStyle={tooltipStyle}
                                                    primaryColor={cfg.primaryColor}
                                                    hexColorSuffix={sellerColorSuffixDark}    
                                                />
                                                {/*  onKeyDown={(e) => e.key === 'Enter' && add_to_wishlist_local(p)} */}
                                                {cfg.showWishlist && (
                                                    <ProductActionButton
                                                        onClick={() => add_to_wishlist_local(p)}
                                                        icon={<FaHeart size={17} />}
                                                        tooltip={<>Add To<br />Wishlist</>}
                                                        tooltipStyle={tooltipStyle}
                                                        primaryColor={cfg.primaryColor}
                                                        hexColorSuffix={sellerColorSuffixDark}
                                                    />
                                                )}

                                                <li>
                                                    <Link
                                                        onClick={() => openModal(p)}
                                                        className="w-9 h-9 cursor-pointer bg-white flex justify-center
                                                            items-center rounded-full shadow-md border border-gray-100
                                                            transition-transform duration-200 hover:scale-110 active:scale-95"
                                                        aria-label="Quick view"
                                                        style={{ borderColor: cfg.primaryColor + sellerColorSuffixDark }}>
                                                        <div className="icon-container">
                                                            <span className="icon flex justify-center items-center text-sm"
                                                                style={{ 
                                                                    color: cfg.primaryColor + sellerColorSuffixDark,
                                                                    borderColor: cfg.primaryColor + sellerColorSuffixDark
                                                                }}>
                                                                <FaEye size={18} />
                                                            </span>
                                                            <div className="tooltip" style={tooltipStyle}>Quick<br />View</div>
                                                        </div>
                                                    </Link>
                                                </li>
                                                {/*  onKeyDown={(e) => e.key === 'Enter' && redirect_chat_page(p.name)} */}
                                                {cfg.showChat && (
                                                    <ProductActionButton
                                                        onClick={() => redirect_chat_page(p.name)}
                                                        icon={<IoChatbubbleEllipsesSharp size={18} />}
                                                        tooltip={<>Chat<br />With Us</>}
                                                        tooltipStyle={tooltipStyle}
                                                        primaryColor={cfg.primaryColor}
                                                        hexColorSuffix={sellerColorSuffixDark}
                                                    />
                                                )}
                                            </ul>
                                        </div>

                                        {/* ── Body ── */}
                                        <div className="flex gap-2 px-3 pt-3 pb-1">
                                            <div
                                                className="w-[5px] h-5 rounded-full"
                                                style={{ backgroundColor: cfg.primaryColor + sellerColorSuffixMedium }}
                                            />
                                            
                                            {/* Name */}
                                            <div
                                                className="text-base font-semibold leading-snug tracking-tight"
                                                style={{ color: cfg.primaryColor + sellerColorSuffixDark }}>
                                                {p.name}
                                            </div>

                                            {/* Decorative rule */}
                                            <div
                                                className="hidden h-px w-8"
                                                style={{ backgroundColor: cfg.primaryColor }}
                                            />

                                            {/* Price + rating row */}
                                            <div className="flex  justify-start items-start gap-1">
                                                {cfg.showPayments && (
                                                    <span
                                                        className="text-base font-bold"
                                                        style={{ color: cfg.primaryColor + sellerColorSuffixDark }}>
                                                        {currencyFormat.format(p.price)}
                                                    </span>
                                                )}
                                                {cfg.showRating && (
                                                    <span className="hidden scale-90 origin-right">
                                                        <Rating ratings={p.rating} />
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {/* ── Portion size or description ── */}
                                        <div className="px-3 pb-2">
                                            {p.portionSizes ? (
                                                <select
                                                    value={portionSize}
                                                    onChange={(e) => setProductPortionSize(p._id, e.target.value)}
                                                    className="w-full h-8 px-2 text-[13px] font-medium rounded-lg
                                                            border bg-white transition-shadow duration-150
                                                            focus:outline-none focus:ring-1"
                                                    style={{
                                                        borderColor: cfg.primaryColor + sellerColorSuffixMedium,
                                                        color:       cfg.primaryColor + sellerColorSuffixDark,
                                                        // focus ring via inline is tricky — handled via global CSS below
                                                    }}>
                                                    <option value="">Choose Portion Size</option>
                                                    {p.portionSizes.split(';').map((size) => (
                                                        <option key={size} value={size}>{size}</option>
                                                    ))}
                                                </select>
                                            ) : (
                                                descSnippet && (
                                                    <p
                                                        className="text-[12px] leading-relaxed"
                                                        style={{ color: cfg.primaryColor + sellerColorSuffixMedium }}>
                                                        {descSnippet}
                                                    </p>
                                                )
                                            )}
                                        </div>

                                        {/* ── Add to cart ── */}
                                        <div className="px-3 pb-3">
                                            <button
                                                onClick={() => add_to_cart_local(p._id)}
                                                className="w-full h-9 flex items-center justify-center gap-1.5
                                                        rounded-lg text-sm font-semibold text-white
                                                        transition-all duration-200 hover:opacity-90
                                                        hover:shadow-md active:scale-[0.98]"
                                                style={{ backgroundColor: cfg.primaryColor + sellerColorSuffixDark }}
                                                aria-label={userInfo
                                                    ? `Add ${p.name} to ${cfg.shoppingTerm}`
                                                    : 'Login to add to cart'}>
                                                {userInfo
                                                    ? <><MdOutlineRestaurantMenu className="text-base" /> Add To {cfg.shoppingTerm}</>
                                                    : <><FaUser className="text-base" /> Login or Register</>
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>

                {/* Pagination dots */}
                <div className="w-full flex justify-center items-center py-2 border-none border-black">
                    <div className="custom_bullet justify-center gap-3 !w-auto" />
                </div>
            </div>

            <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
        </>
    );
};

export default SwiperProducts;



//refactored
// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaHeart } from "react-icons/fa6";
// import { FaEye } from "react-icons/fa";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { FaUser } from "react-icons/fa6";

// import { Pagination } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import { Swiper, SwiperSlide } from 'swiper/react';

// import { add_to_cart, add_to_wishlist, messageClear } from '../../store/reducers/cartReducer';
// import { currencyFormat } from '../CurrencyFormat';
// import Rating from '../Rating';
// import SkeletonWithImage from '../SkeletonWithImage';
// import Modal2 from '../Modal2';
// import toast from 'react-hot-toast';

// // ─── Action icon button ──────────────────────────────────────────────────────
// const ProductActionButton = ({ onClick, onKeyDown, icon, tooltip, tooltipStyle, className = '' }) => (
//     <li
//         role="button"
//         tabIndex={0}
//         onClick={onClick}
//         onKeyDown={onKeyDown}
//         className={`w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all ${className}`}
//     >
//         <div className="icon-container">
//             <span className="icon flex justify-center items-center">&nbsp;{icon}&nbsp;</span>
//             <div className="tooltip" style={tooltipStyle}>{tooltip}</div>
//         </div>
//     </li>
// );

// // ─── Main component ──────────────────────────────────────────────────────────
// const SwiperProducts = ({ products, title, suppressToasts = false }) => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     const { seller }   = useSelector(state => state.seller);
//     const { userInfo } = useSelector(state => state.auth);
//     const { errorMessage, successMessage } = useSelector(state => state.cart);

//     // Memoize all seller-derived config so it doesn't recompute every render
//     const cfg = useMemo(() => ({
//         primaryColor:   seller?.frontEndPrimaryColor1,
//         secondaryColor: seller?.frontEndSecondaryColor1,
//         shoppingTerm:   seller?.shoppingTerm,
//         productPlural:  seller?.productPluralTerm,
//         showPayments:   seller?.isVisibleSitePayments === 'Show',
//         showWishlist:   seller?.isVisibleSiteWishlist === 'Show',
//         showRating:     seller?.isVisibleSiteRating   === 'Show',
//         showChat:       seller?.isVisibleSiteChat     === 'Show',
//     }), [seller]);

//     const tooltipStyle = useMemo(() => ({
//         color: 'white',
//         backgroundColor: cfg.primaryColor,
//     }), [cfg.primaryColor]);

//     const cardStyle = useMemo(() => ({
//         color:           cfg.primaryColor,
//         borderColor:     cfg.primaryColor,
//         backgroundColor: cfg.secondaryColor,
//     }), [cfg.primaryColor, cfg.secondaryColor]);

//     // Per-product portion sizes — fixes shared-state bug
//     const [portionSizes, setPortionSizes] = useState({});
//     const setProductPortionSize = useCallback((productId, size) =>
//         setPortionSizes(prev => ({ ...prev, [productId]: size })), []);

//     // Modal state
//     const [modalProduct, setModalProduct] = useState(null);
//     const openModal  = useCallback((product) => setModalProduct(product), []);
//     const closeModal = useCallback(() => setModalProduct(null), []);

//     // Navigation helpers
//     const redirect_chat_page = useCallback((chatTopic) => {
//         navigate(userInfo ? `/customerDashboard/chat/${chatTopic}` : '/login');
//     }, [userInfo, navigate]);

//     // Cart / wishlist actions
//     const add_to_cart_local = useCallback((productId) => {
//         if (!userInfo) { navigate('/login'); return; }
//         dispatch(add_to_cart({
//             userId: userInfo.id,
//             quantity: 1,
//             productId,
//             portionSize: portionSizes[productId] ?? '',
//         }));
//     }, [userInfo, navigate, dispatch, portionSizes]);

//     const add_to_wishlist_local = useCallback((p) => {
//         if (!userInfo) { navigate('/login'); return; }
//         dispatch(add_to_wishlist({
//             userId:       userInfo.id,
//             productId:    p._id,
//             name:         p.name,
//             price:        p.price,
//             image:        p.images[0],
//             discount:     p.discount,
//             rating:       p.rating,
//             slug:         p.slug,
//             portionSizes: p.portionSizes,
//             description:  p.description,
//             byThePan:     p.byThePan,
//         }));
//     }, [userInfo, navigate, dispatch]);

//     // Toast handling — deps array now complete
//     useEffect(() => {
//         if (suppressToasts) return;
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage, suppressToasts, dispatch]);

//     if (!products || products.length === 0) return null;

//     return (
//         <>
//             <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//                 <h2
//                     className='text-2xl py-2 pl-3 border mb-2'
//                     style={{ color: cfg.primaryColor, borderColor: cfg.primaryColor, backgroundColor: cfg.secondaryColor }}
//                 >
//                     {title || `Related ${cfg.productPlural}`}
//                 </h2>

//                 <div>
//                     <Swiper
//                         slidesPerView='auto'
//                         breakpoints={{ 1280: { slidesPerView: 3 }, 565: { slidesPerView: 2 } }}
//                         spaceBetween={10}
//                         loop={true}
//                         pagination={{ clickable: true, el: '.custom_bullet' }}
//                         modules={[Pagination]}
//                         className='mySwiper'
//                     >
//                         {products.map((p) => {
//                             const portionSize    = portionSizes[p._id] ?? '';
//                             const actionBtnStyle = {
//                                 backgroundColor: 'white',
//                                 color:           cfg.primaryColor,
//                                 borderColor:     cfg.primaryColor,
//                             };

//                             // Description snippet with proper ellipsis guard
//                             const descSnippet = p.description
//                                 ? p.description.length > 32
//                                     ? `${p.description.substring(0, 32)} ...`
//                                     : p.description
//                                 : '';

//                             return (
//                                 <SwiperSlide key={p._id}>
//                                     <div className='block border-2' style={cardStyle}>

//                                         {/* ── Image + hover actions ─────────────────── */}
//                                         <div className='w-full relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden'>
//                                             <SkeletonWithImage
//                                                 className='w-full h-[270px] object-cover'
//                                                 src={p.images[0]}
//                                                 alt={p.name}
//                                             />
//                                             <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3'>
//                                                 <ProductActionButton
//                                                     onClick={() => add_to_cart_local(p._id)}
//                                                     onKeyDown={(e) => e.key === 'Enter' && add_to_cart_local(p._id)}
//                                                     icon={<><span>+</span><MdOutlineRestaurantMenu /></>}
//                                                     tooltip={<>Add To<br />{cfg.shoppingTerm}</>}
//                                                     tooltipStyle={tooltipStyle}
//                                                     className=''
//                                                     style={actionBtnStyle}
//                                                 />

//                                                 {cfg.showWishlist && (
//                                                     <ProductActionButton
//                                                         onClick={() => add_to_wishlist_local(p)}
//                                                         onKeyDown={(e) => e.key === 'Enter' && add_to_wishlist_local(p)}
//                                                         icon={<FaHeart />}
//                                                         tooltip={<>Add To<br />Wishlist</>}
//                                                         tooltipStyle={tooltipStyle}
//                                                         style={actionBtnStyle}
//                                                     />
//                                                 )}

//                                                 {/* Quick view uses Link semantics — keep as-is */}
//                                                 <li>
//                                                     <Link
//                                                         onClick={() => openModal(p)}
//                                                         className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                                         style={actionBtnStyle}
//                                                         aria-label='Quick view'
//                                                     >
//                                                         <div className="icon-container">
//                                                             <span className='icon flex justify-center items-center'>
//                                                                 &nbsp;<FaEye />&nbsp;
//                                                             </span>
//                                                             <div className="tooltip" style={tooltipStyle}>Quick<br />View</div>
//                                                         </div>
//                                                     </Link>
//                                                 </li>

//                                                 {cfg.showChat && (
//                                                     <ProductActionButton
//                                                         onClick={() => redirect_chat_page(p.name)}
//                                                         onKeyDown={(e) => e.key === 'Enter' && redirect_chat_page(p.name)}
//                                                         icon={<IoChatbubbleEllipsesSharp />}
//                                                         tooltip={<>Chat<br />With Us</>}
//                                                         tooltipStyle={tooltipStyle}
//                                                         style={actionBtnStyle}
//                                                     />
//                                                 )}
//                                             </ul>
//                                         </div>

//                                         {/* ── Name + price + rating ─────────────────── */}
//                                         <div className='p-1 flex flex-col gap-1' style={{ color: cfg.primaryColor }}>
//                                             <div className='text-lg font-bold'>{p.name}</div>
//                                             <div className='flex justify-start items-center gap-3'>
//                                                 {cfg.showPayments && (
//                                                     <div className='text-lg font-bold'>
//                                                         {currencyFormat.format(p.price)}
//                                                     </div>
//                                                 )}
//                                                 {cfg.showRating && <Rating ratings={p.rating} />}
//                                             </div>
//                                         </div>

//                                         {/* ── Portion size or description ───────────── */}
//                                         <div className='w-full'>
//                                             {p.portionSizes ? (
//                                                 <select
//                                                     value={portionSize}
//                                                     onChange={(e) => setProductPortionSize(p._id, e.target.value)}
//                                                     className='border rounded-md px-3 m-1 w-[97%] h-[28px] text-[14px] font-semibold'
//                                                     style={{
//                                                         borderColor:     cfg.primaryColor,
//                                                         color:           cfg.primaryColor,
//                                                         backgroundColor: cfg.secondaryColor,
//                                                     }}
//                                                 >
//                                                     <option value=''>Choose Portion Size</option>
//                                                     {p.portionSizes.split(';').map((size) => (
//                                                         <option key={size} value={size}>{size}</option>
//                                                     ))}
//                                                 </select>
//                                             ) : (
//                                                 <div
//                                                     className='py-1 px-1 m-1 w-[97%] border text-[14px] font-semibold'
//                                                     style={{
//                                                         borderColor:     cfg.primaryColor,
//                                                         color:           cfg.primaryColor,
//                                                         backgroundColor: cfg.secondaryColor,
//                                                     }}
//                                                 >
//                                                     {descSnippet}
//                                                 </div>
//                                             )}
//                                         </div>

//                                         {/* ── Add to cart button ────────────────────── */}
//                                         <div className='w-full justify-center items-center'>
//                                             <button
//                                                 onClick={() => add_to_cart_local(p._id)}
//                                                 className='px-1 py-1 m-1 h-[34px] flex w-[97%] rounded-lg text-md cursor-pointer justify-center items-center hover:shadow-lg text-white'
//                                                 style={{ backgroundColor: cfg.primaryColor }}
//                                                 aria-label={userInfo ? `Add ${p.name} to ${cfg.shoppingTerm}` : 'Login to add to cart'}
//                                             >
//                                                 {userInfo
//                                                     ? <><MdOutlineRestaurantMenu className='mr-1' /> Add To {cfg.shoppingTerm}</>
//                                                     : <><FaUser className='mr-1' /> Please Login Or Register</>
//                                                 }
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </SwiperSlide>
//                             );
//                         })}
//                     </Swiper>
//                 </div>

//                 <div className='w-full flex justify-center items-center py-8'>
//                     <div className='custom_bullet justify-center gap-3 !w-auto' />
//                 </div>
//             </div>

//             <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
//         </>
//     );
// };

// export default SwiperProducts;




//my original code
// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaHeart } from "react-icons/fa6";
// import { FaEye } from "react-icons/fa";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { FaUser } from "react-icons/fa6";

// import { Pagination } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import { Swiper, SwiperSlide } from 'swiper/react';

// import { add_to_cart, add_to_wishlist, messageClear  } from '../../store/reducers/cartReducer';

// import { currencyFormat } from '../CurrencyFormat';
// import Rating from '../Rating';
// import SkeletonWithImage from '../SkeletonWithImage';
// import Modal2 from '../Modal2';
// import toast from 'react-hot-toast';

// const SwiperProducts = ({ products, title, suppressToasts = false }) => {

//     const dispatch  = useDispatch()
//     const navigate  = useNavigate()

//     const { seller }   = useSelector(state => state.seller)
//     const { userInfo } = useSelector(state => state.auth)
//     const { errorMessage, successMessage } = useSelector(state => state.cart)

//     const sellerPrimaryColor1     = seller?.frontEndPrimaryColor1
//     const sellerSecondaryColor1   = seller?.frontEndSecondaryColor1
//     const sellerShoppingTerm      = seller?.shoppingTerm
//     const sellerProductPluralTerm = seller?.productPluralTerm

//     const sellerBoolShowSitePayments = seller?.isVisibleSitePayments === 'Show'
//     const sellerBoolShowSiteWishList = seller?.isVisibleSiteWishlist === 'Show'
//     const sellerBoolShowSiteRating   = seller?.isVisibleSiteRating   === 'Show'
//     const sellerBoolShowSiteChat     = seller?.isVisibleSiteChat     === 'Show'

//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1,
//     }

//     const [portionSize, setPortionSize] = useState('')
//     const [modalProduct, setModalProduct] = useState(null)

//     const openModal  = (product) => setModalProduct(product)
//     const closeModal = () => setModalProduct(null)

//     const redirect_chat_page = (chatTopic) => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/${chatTopic}`)
//         } else {
//             navigate('/login')
//         }
//     }

//     const add_to_cart_local = (productId) => {
//         if (userInfo) {
//             dispatch(add_to_cart({
//                 userId: userInfo.id,
//                 quantity: 1,
//                 productId,
//                 portionSize,
//             }))
//             setPortionSize('')
//         } else {
//             navigate('/login')
//         }
//     }

//     const add_to_wishlist_local = (p) => {
//         if (userInfo) {
//             dispatch(add_to_wishlist({
//                 userId:       userInfo.id,
//                 productId:    p._id,
//                 name:         p.name,
//                 price:        p.price,
//                 image:        p.images[0],
//                 discount:     p.discount,
//                 rating:       p.rating,
//                 slug:         p.slug,
//                 portionSizes: p.portionSizes,
//                 description:  p.description,
//                 byThePan:     p.byThePan,
//             }))
//         } else {
//             navigate('/login')
//         }
//     }
//     // Add this useEffect inside the component
//     useEffect(() => {
//         if (suppressToasts) return   // ← exits if parent is handling toasts
//         if (successMessage) {
//             toast.success(successMessage)
//             setPortionSize('')
//             dispatch(messageClear())
//         }
//         if (errorMessage) {
//             toast.error(errorMessage)
//             setPortionSize('')
//             dispatch(messageClear())
//         }
//     }, [successMessage, errorMessage])

//     if (!products || products.length === 0) return null

//     return (
//         <>
//             <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//                 <h2 className='text-2xl py-2 pl-3 border mb-2'
//                     style={{ color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}>
//                     {title || `Related ${sellerProductPluralTerm}`}
//                 </h2>
//                 <div>
//                     <Swiper
//                         slidesPerView='auto'
//                         breakpoints={{ 1280: { slidesPerView: 3 }, 565: { slidesPerView: 2 } }}
//                         spaceBetween={10}
//                         loop={true}
//                         pagination={{ clickable: true, el: '.custom_bullet' }}
//                         modules={[Pagination]}
//                         className='mySwiper'>
//                         {products.map((p, i) => (
//                             <SwiperSlide key={i}>
//                                 <div className='block border-2'
//                                     style={{ color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}>

//                                     {/* Image + hover actions */}
//                                     <div className='w-full relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden'>
//                                         <SkeletonWithImage className='w-full h-[270px] object-cover' src={p.images[0]} alt={p.name} />
//                                         <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3'>
//                                             <li onClick={() => add_to_cart_local(p._id)}
//                                                 className='w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all'
//                                                 style={{ backgroundColor: 'white', color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                                 <div className="icon-container">
//                                                     <span className='icon flex justify-center items-center'>
//                                                         +<MdOutlineRestaurantMenu />&nbsp;
//                                                     </span>
//                                                     <div className="tooltip" style={tooltipHoverStyle}>Add To<br />{sellerShoppingTerm}</div>
//                                                 </div>
//                                             </li>
//                                             <li onClick={() => add_to_wishlist_local(p)}
//                                                 className={`${sellerBoolShowSiteWishList ? '' : 'hidden'} w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all`}
//                                                 style={{ backgroundColor: 'white', color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                                 <div className="icon-container">
//                                                     <span className='icon flex justify-center items-center'>
//                                                         &nbsp;<FaHeart />&nbsp;
//                                                     </span>
//                                                     <div className="tooltip" style={tooltipHoverStyle}>Add To<br />Wishlist</div>
//                                                 </div>
//                                             </li>
//                                             <li>
//                                                 <Link onClick={() => openModal(p)}
//                                                     className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                                     style={{ backgroundColor: 'white', color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                                     <div className="icon-container">
//                                                         <span className='icon flex justify-center items-center'>
//                                                             &nbsp;<FaEye />&nbsp;
//                                                         </span>
//                                                         <div className="tooltip" style={tooltipHoverStyle}>Quick<br />View</div>
//                                                     </div>
//                                                 </Link>
//                                             </li>
//                                             <li onClick={() => redirect_chat_page(p.name)}
//                                                 className={`${sellerBoolShowSiteChat ? '' : 'hidden'} w-[38px] h-[38px] cursor-pointer bg-white border flex justify-center items-center rounded-full transition-all`}
//                                                 style={{ backgroundColor: 'white', color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                                 <div className="icon-container">
//                                                     <span className='icon flex justify-center items-center'>
//                                                         &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                                     </span>
//                                                     <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                                 </div>
//                                             </li>
//                                         </ul>
//                                     </div>

//                                     {/* Name + price + rating */}
//                                     <div className='p-1 flex flex-col gap-1' style={{ color: sellerPrimaryColor1 }}>
//                                         <div className='text-lg font-bold'>{p.name}</div>
//                                         <div className='flex justify-start items-center gap-3'>
//                                             <div className={`${sellerBoolShowSitePayments ? 'text-lg font-bold' : 'hidden'}`}>
//                                                 {currencyFormat.format(p.price)}
//                                             </div>
//                                             <div className={`${sellerBoolShowSiteRating ? 'flex' : 'hidden'}`}>
//                                                 <Rating ratings={p.rating} />
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {/* Portion size selector or description snippet */}
//                                     {p.portionSizes !== '' ? (
//                                         <div className='w-full'>
//                                             <select onChange={(e) => setPortionSize(e.target.value)}
//                                                 className='border rounded-md px-3 m-1 w-[97%] h-[28px] text-[14px] font-semibold'
//                                                 style={{ borderColor: sellerPrimaryColor1, color: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}>
//                                                 <option value=''>Choose Portion Size</option>
//                                                 {p.portionSizes.split(';').map((size, j) => (
//                                                     <option key={j} value={size}>{size}</option>
//                                                 ))}
//                                             </select>
//                                         </div>
//                                     ) : (
//                                         <div className='w-full'>
//                                             <div className='py-1 px-1 m-1 w-[97%] border text-[14px] font-semibold'
//                                                 style={{ borderColor: sellerPrimaryColor1, color: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}>
//                                                 {p.description?.substring(0, 32)} ...
//                                             </div>
//                                         </div>
//                                     )}

//                                     {/* Add to cart button */}
//                                     <div className='w-full justify-center items-center'>
//                                         <button onClick={() => add_to_cart_local(p._id)}
//                                             className='px-1 py-1 m-1 h-[34px] flex w-[97%] rounded-lg text-md cursor-pointer justify-center items-center hover:shadow-lg text-white'
//                                             style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                             {userInfo
//                                                 ? <><MdOutlineRestaurantMenu className='mr-1' /> Add To {sellerShoppingTerm}</>
//                                                 : <><FaUser className='mr-1' /> Please Login Or Register</>
//                                             }
//                                         </button>
//                                     </div>
//                                 </div>
//                             </SwiperSlide>
//                         ))}
//                     </Swiper>
//                 </div>
//                 <div className='w-full flex justify-center items-center py-8'>
//                     <div className='custom_bullet justify-center gap-3 !w-auto'></div>
//                 </div>
//             </div>

//             <Modal2 isOpen={!!modalProduct} onClose={closeModal} product={modalProduct} />
//         </>
//     )
// }

// export default SwiperProducts;






//first version from claude
// import React, { useEffect, useState, lazy }  from 'react';
// import { Link, useNavigate, useParams } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaUser, FaHeart } from "react-icons/fa6";
// import { FaEye } from "react-icons/fa";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";

// import { add_to_cart, add_to_wishlist, messageClear } from '../../store/reducers/cartReducer';

// import { Pagination } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import { Swiper, SwiperSlide } from 'swiper/react';

// import Rating from '../Rating';
// import SkeletonWithImage from '../SkeletonWithImage';
// import { currencyFormat } from '../CurrencyFormat';
// import toast from 'react-hot-toast';

// const SwiperProducts = ({ title, products,
//     onAddToCart,
//     onAddToWishlist,
//     onOpenModal,
//     onRedirectChat,
//     portionSize,
//     setPortionSize,
    
//     }) => {
//     const { seller } = useSelector(state => state.seller);
//     const { userInfo } = useSelector(state => state.auth)
//     const { errorMessage, successMessage } = useSelector(state => state.cart)
        
//     const sellerPrimaryColor1     = seller?.frontEndPrimaryColor1;
//     const sellerSecondaryColor1   = seller?.frontEndSecondaryColor1;
//     const sellerShoppingTerm      = seller?.shoppingTerm;
//     const sellerProductPluralTerm = seller?.productPluralTerm;

//     const sellerBoolShowSitePayments  = seller?.isVisibleSitePayments === 'Show';
//     const sellerBoolShowSiteWishList  = seller?.isVisibleSiteWishlist === 'Show';
//     const sellerBoolShowSiteRating    = seller?.isVisibleSiteRating   === 'Show';
//     const sellerBoolShowSiteChat      = seller?.isVisibleSiteChat     === 'Show';
    
//     const dispatch = useDispatch()
    
//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1,
//     };
//     //const [portionSize, setPortionSize] = useState('')
    
//     // useEffect(() => { 
//     //     if (successMessage) {
//     //         toast.success(successMessage)
//     //         setPortionSize('')
//     //         dispatch(messageClear())  
//     //     } 
//     //     if (errorMessage) {
//     //         toast.error(errorMessage)
//     //         setPortionSize('')
//     //         dispatch(messageClear())  
//     //     } 
//     // },[successMessage, errorMessage])
    

//     if (!products || products.length === 0) return null;

//     return (
//         <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//             <h2 className='text-2xl py-2 pl-3 border mb-2'
//                 style={{ color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}>
//                 {title}
//             </h2>
//             <div>
//                 <Swiper
//                     slidesPerView='auto'
//                     breakpoints={{ 1280: { slidesPerView: 3 }, 565: { slidesPerView: 2 } }}
//                     spaceBetween={10}
//                     loop={true}
//                     pagination={{ clickable: true, el: '.custom_bullet' }}
//                     modules={[Pagination]}
//                     className='mySwiper'>
//                     {products.map((p, i) => (
//                         <SwiperSlide key={i}>
//                             <div className='block border-2'
//                                 style={{ color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}>

//                                 {/* Image + hover actions */}
//                                 <div className='w-full relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden'>
//                                     <SkeletonWithImage className='w-full h-[270px] object-cover' src={p.images[0]} alt="" />
//                                     <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3'>
//                                         <li onClick={() => onAddToCart(p._id)}
//                                             className='w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all'
//                                             style={{ backgroundColor: 'white', color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                             <div className="icon-container">
//                                                 <span className='icon flex justify-center items-center'>
//                                                     +<MdOutlineRestaurantMenu />&nbsp;
//                                                 </span>
//                                                 <div className="tooltip" style={tooltipHoverStyle}>Add To<br />{sellerShoppingTerm}</div>
//                                             </div>
//                                         </li>
//                                         <li onClick={() => onAddToWishlist(p)}
//                                             className={`${sellerBoolShowSiteWishList ? '' : 'hidden'} w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all`}
//                                             style={{ backgroundColor: 'white', color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                             <div className="icon-container">
//                                                 <span className='icon flex justify-center items-center'>
//                                                     &nbsp;<FaHeart />&nbsp;
//                                                 </span>
//                                                 <div className="tooltip" style={tooltipHoverStyle}>Add To<br />Wishlist</div>
//                                             </div>
//                                         </li>
//                                         <li>
//                                             <Link onClick={() => onOpenModal(p)}
//                                                 className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
//                                                 style={{ backgroundColor: 'white', color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                                 <div className="icon-container">
//                                                     <span className='icon flex justify-center items-center'>
//                                                         &nbsp;<FaEye />&nbsp;
//                                                     </span>
//                                                     <div className="tooltip" style={tooltipHoverStyle}>Quick<br />View</div>
//                                                 </div>
//                                             </Link>
//                                         </li>
//                                         <li onClick={() => onRedirectChat(p.name)}
//                                             className={`${sellerBoolShowSiteChat ? '' : 'hidden'} w-[38px] h-[38px] cursor-pointer bg-white border flex justify-center items-center rounded-full transition-all`}
//                                             style={{ backgroundColor: 'white', color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1 }}>
//                                             <div className="icon-container">
//                                                 <span className='icon flex justify-center items-center'>
//                                                     &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                                 </span>
//                                                 <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                             </div>
//                                         </li>
//                                     </ul>
//                                 </div>

//                                 {/* Name + price + rating */}
//                                 <div className='p-1 flex flex-col gap-1' style={{ color: sellerPrimaryColor1 }}>
//                                     <div className='text-lg font-bold'>{p.name}</div>
//                                     <div className='flex justify-start items-center gap-3'>
//                                         <div className={`${sellerBoolShowSitePayments ? 'text-lg font-bold' : 'hidden'}`}>
//                                             {currencyFormat.format(p.price)}
//                                         </div>
//                                         <div className={`${sellerBoolShowSiteRating ? 'flex' : 'hidden'}`}>
//                                             <Rating ratings={p.rating} />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Portion size selector or description snippet */}
//                                 {p.portionSizes !== '' ? (
//                                     <div className='w-full'>
//                                         <select onChange={(e) => setPortionSize(e.target.value)}
//                                             className='border rounded-md px-3 m-1 w-[97%] h-[28px] text-[14px] font-semibold'
//                                             style={{ borderColor: sellerPrimaryColor1, color: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}>
//                                             <option value=''>Choose Portion Size</option>
//                                             {p.portionSizes.split(';').map((size, j) => (
//                                                 <option key={j} value={size}>{size}</option>
//                                             ))}
//                                         </select>
//                                     </div>
//                                 ) : (
//                                     <div className='w-full'>
//                                         <div className='py-1 px-1 m-1 w-[97%] border text-[14px] font-semibold'
//                                             style={{ borderColor: sellerPrimaryColor1, color: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}>
//                                             {p.description?.substring(0, 32)} ...
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* Add to cart button */}
//                                 <div className='w-full justify-center items-center'>
//                                     <button onClick={() => onAddToCart(p._id)}
//                                         className='px-1 py-1 m-1 h-[34px] flex w-[97%] rounded-lg text-md cursor-pointer justify-center items-center hover:shadow-lg text-white'
//                                         style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                         {userInfo
//                                             ? <><MdOutlineRestaurantMenu className='mr-1' /> Add To {sellerShoppingTerm}</>
//                                             : <><FaUser className='mr-1' /> Please Login Or Register</>
//                                         }
//                                     </button>
//                                 </div>
//                             </div>
//                         </SwiperSlide>
//                     ))}
//                 </Swiper>
//             </div>
//             <div className='w-full flex justify-center items-center py-8'>
//                 <div className='custom_bullet justify-center gap-3 !w-auto'></div>
//             </div>
//         </div>
//     );
// };

// export default SwiperProducts;




